import React, { createContext, useContext, useState } from 'react';

const ModeContext = createContext(null);

export const useMode = () => {
  const context = useContext(ModeContext);
  if (!context) {
    throw new Error('useMode must be used within a ModeProvider');
  }
  return context;
};

export const ModeProvider = ({ children }) => {
  const [mode, setMode] = useState('labs'); // 'labs' or 'callup'

  const toggleMode = () => {
    setMode(prev => prev === 'labs' ? 'callup' : 'labs');
  };

  const isLabs = mode === 'labs';
  const isCallUp = mode === 'callup';

  return (
    <ModeContext.Provider value={{ mode, setMode, toggleMode, isLabs, isCallUp }}>
      {children}
    </ModeContext.Provider>
  );
};

export default ModeContext;
